import moment from 'moment';

const dateStringToUnix = (date: string): number => {
    return moment.utc(date).unix() * 1000;
};

export default dateStringToUnix;
